module.exports = __webpack_public_path__ + "img/milestone.f3252eaa.svg";